import {ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormRatingComponent} from '../../../../shared/elements/form-rating/form-rating.component';
import {TranslatePipe} from '../../../../shared/pipes/translate.pipe';
import {FeedbackQuestionType} from '../../../../shared/types/generated/feedbackQuestionType';
import {FeedbackStructureQuestionFormQuestion, FeedbackStructureRatingQuestion} from '../../feedback-structure-create-update-dialog/feedback-structure-question/feedback-structure-question-form.model';
import {feedbackAnswerControlName} from '../../helpers/feedback-structure-preview-control-names';

@Component({
	selector: 'app-feedback-form-element-rating',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FormRatingComponent, TranslatePipe],
	template: `
		<div class="ps-md-3 d-flex flex-column align-items-center w-100">
			<app-form-rating
				[fG]="formGroup()"
				[fCN]="answerControlName()"
				[halfStep]="ratingQuestion().configuration.allow_half_stars"
				[allowReset]="!ratingQuestion().required"
				[errorText]="'INPUTREQUIRED' | translate"
				[disabled]="disabled()"
			></app-form-rating>
		</div>
	`,
})
export class FeedbackFormElementRatingComponent {
	public question: InputSignal<FeedbackStructureQuestionFormQuestion> = input.required();
	public formGroup: InputSignal<FormGroup> = input.required();
	public controlNamePrefix: InputSignal<string> = input('preview');
	public disabled: InputSignal<boolean> = input(false);

	public ratingQuestion: Signal<FeedbackStructureRatingQuestion> = computed(() => {
		const question = this.question();
		if (question.type !== FeedbackQuestionType.RATING) {
			throw new Error('FeedbackFormElementRatingComponent requires a rating question.');
		}

		return question;
	});

	public answerControlName(): string {
		return feedbackAnswerControlName(this.question(), this.controlNamePrefix());
	}
}
